import styled from 'styled-components';
import { TextAreaStyled } from '../TextAreaStyled';

export const TextAreaStyledAP = styled(TextAreaStyled)``;
